import React from 'react'
import { Reports as ReportsView } from '@layerfi/components'

import { AccountingLayout } from '../../../layouts/AccountingLayout'

export const Reports = () => {
  return (
    <AccountingLayout>
      <ReportsView
        profitAndLossConfig={{
          defaultDatePickerMode: 'dayRangePicker',
          allowedDatePickerModes: ['monthPicker', 'dayRangePicker'],
        }}
        statementOfCashFlowConfig={{
          allowedDatePickerModes: ['monthPicker', 'dayRangePicker'],
        }}
      />
    </AccountingLayout>
  )
}
